define([
    './directives/PAQuickAdditionalEditState',
    './directives/PAQuickAdditionalInfoState',
    './directives/PAQuickAdditionalTile'
], (
    PAQuickAdditionalEditState,
    PAQuickAdditionalInfoState,
    PAQuickAdditionalTile
) =>{
    angular.module('edge.quoteandbind.quickquote.pa.tiles.additional', [])
        .directive('gwPaQuickAdditionalEditState', PAQuickAdditionalEditState)
        .directive('gwPaQuickAdditionalInfoState', PAQuickAdditionalInfoState)
        .directive('gwPaQuickAdditionalTile', PAQuickAdditionalTile);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/additional/app.js
 **/